import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Tab from './Tab';

class Tabs extends Component {
    static propTypes = {
        children: PropTypes.instanceOf(Array).isRequired,
    }

    constructor(props) {
        super(props);
        const first = props.children[0].props;
        this.state = {
            activeTab: first.tabKey != null ? first.tabKey : first.label,
        };
    }

    onClickTabItem = (tab) => {
        this.setState({ activeTab: tab });
    }

    render() {
        const {
            onClickTabItem,
            props: {
                children,
            },
            state: {
                activeTab,
            }
        } = this;

        return (
            <div className="tabs">
                <ol className="tab-list">
                    {
                        children.map((child) => {
                            const { label, tabKey } = child.props;
                            const id = tabKey != null ? tabKey : label;
                            return (
                                <Tab
                                    activeTab={activeTab}
                                    key={id}
                                    tabKey={tabKey}
                                    label={label}
                                    onClick={onClickTabItem}
                                />
                            );
                        })
                    }
                </ol>
                <div className="tab-content">
                    {children.map((child) => {
                      const id = child.props.tabKey != null ? child.props.tabKey : child.props.label;
                      if (id !== activeTab) return undefined;
                      return child.props.children;
                    })}
                </div>
            </div>
        );
    }
}

export default Tabs;